<template>
    <div class="slider">
        <div class="slider-item" v-for="p in pickups" :key="p.id">
            <pickup :novel="p"></pickup>
        </div>
    </div>
</template>

<style scoped lang="scss">
.slider {
    display: flex;
    overflow: scroll;
    margin: 0 30px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display:none;
    }
    .slider-item {
        padding: 5px 15px;
    }
}
</style>

<script>
import pickup from "components/Pickup";
export default {
    components: {
        pickup
    },
    props: {
        pickups: {
            required: true
        }
    }
}
</script>